"use client";

/**
 * One line about the budget profile with a link to the affordability
 * calculator. Sits under the rent-versus-buy and mortgage calculators
 * (owner, 2026-09-21: the budget is its own calculator now, but the
 * others keep reading it: they prefill from the profile and show this
 * summary).
 */

import { ChevronRight } from "lucide-react";
import Link from "@/lib/localized-link";
import { useT } from "@/lib/locale-context";
import { formatPrice } from "@/lib/api";
import { useAffordability } from "@/lib/affordability";

export default function BudgetSummaryRow({ className = "" }: { className?: string }) {
  const t = useT();
  const { usable, budget } = useAffordability();
  return (
    <Link
      href="/calculate/affordability"
      className={`flex flex-wrap items-center justify-between gap-x-3 gap-y-1 rounded-xl border border-gray-200 bg-white px-4 py-2.5 text-sm transition-colors hover:border-gray-300 hover:bg-gray-50 ${className}`}
    >
      <span className="min-w-0 text-gray-700">
        {usable && budget
          ? t("afford.row.summary").replace("{n}", formatPrice(budget.maxPrice))
          : t("afford.row.empty")}
      </span>
      <span className="inline-flex shrink-0 items-center gap-1 font-semibold text-gray-900">
        {t("afford.row.cta")}
        <ChevronRight className="h-4 w-4 text-gray-400" />
      </span>
    </Link>
  );
}
